<po-page-default p-title="Carnês e Boletos">
  <po-table
    *ngIf="!isMobile"
    [p-columns]="columns"
    [p-items]="items"
    p-container="border"
    [p-sort]="true"
    [p-literals]="customLiterals"
    [p-striped]="true"
    [p-actions-right]="true"
  >
  </po-table>

  <div *ngIf="isMobile" class="mobile-finance-viewport po-p-2">
  
  <div class="finance-card reveal" *ngFor="let item of items"
       [class.overdue-border]="item.daysLate > 0">
    
    <div class="card-section header-bg">
      <div class="po-row">
        <div class="po-sm-12" *ngIf="item.personName">
          <span class="label-muted">CLIENTE</span>
          <h3 class="value-highlight">{{ item.personName }}</h3>
        </div>
        <div class="po-sm-6">
          <span class="label-muted">FATURA</span>
          <span class="value-small">{{ item.receivableCode }}</span>
        </div>
        <div class="po-sm-6 text-right">
          <span class="label-muted">PARCELA</span>
          <span class="value-small">{{ item.installmentCode }}</span>
        </div>
      </div>
    </div>

    <div class="card-section border-y">
      <div class="po-row">
        <div class="po-sm-4">
          <span class="label-muted">EMISSÃO</span>
          <span class="value-data">{{ item.issueDate | date: "dd/MM/yyyy" }}</span>
        </div>
        <div class="po-sm-4 text-center">
          <span class="label-muted">VENCIMENTO</span>
          <span class="value-data" [class.text-danger]="item.daysLate > 0">
            {{ item.expiredDate | date: "dd/MM/yyyy" }}
          </span>
        </div>
        <div class="po-sm-4 text-right">
          <span class="label-muted">ATRASO</span>
          <span class="value-data" [class.text-danger]="item.daysLate > 0">
            {{ item.daysLate }}d
          </span>
        </div>
      </div>
    </div>

    <div class="card-section bg-neutral-soft">
      <div class="po-row po-mb-1">
        <div class="po-sm-6">
          <span class="label-muted">VALOR PARCELA</span>
          <span class="value-money">{{ item.installmentValue | currency: 'BRL' }}</span>
        </div>
        <div class="po-sm-6 text-right">
          <span class="label-muted">ABATIMENTO</span>
          <span class="value-money text-success">- {{ item.discount | currency: 'BRL' }}</span>
        </div>
      </div>
      <div class="po-row po-mt-1 po-align-items-end">
        <div class="po-sm-6">
          <span class="label-muted">JUROS/MULTA</span>
          <span class="value-money text-warning">+ {{ item.increase | currency: 'BRL' }}</span>
        </div>
        <div class="po-sm-6 text-right">
          <span class="label-muted">VALOR LÍQUIDO</span>
          <span class="value-total">{{ item.finalValue | currency: 'BRL' }}</span>
        </div>
      </div>
    </div>

    <div class="card-section footer-actions" *ngIf="item.columnIcon?.length">
      <span class="label-muted po-mb-2 po-block">FORMA DE PAGAMENTO</span>
      <div class="action-grid">
        <button *ngFor="let icon of item.columnIcon" 
                class="btn-action-lux" 
                (click)="handleAction(icon, item)">
          <i [class]="getIconClass(icon)"></i>
          <span>{{ getLabel(icon) }}</span>
        </button>
      </div>
    </div>

  </div>
</div>

  <div class="po-row totals-minimal-row po-mt-4 po-mb-4">
    <div class="po-md-3 po-sm-12 total-block">
      <span class="total-label">Parcelas</span>
      <span class="total-amount">{{
        (totals.installmentValue | currency: "BRL") ?? "R$0,00"
      }}</span>
    </div>

    <div class="po-md-3 po-sm-12 total-block">
      <span class="total-label">Abatimentos</span>
      <span class="total-amount green-accent"> - {{
        (totals.discountValue | currency: "BRL") ?? "R$ 0,00"
      }}</span>
    </div>

    <div class="po-md-3 po-sm-12 total-block">
      <span class="total-label">Juros</span>
      <span class="total-amount negative"> + {{(totals.increaseValue | currency: "BRL") ?? "R$ 0,00"}}</span>
    </div>

    <div class="po-md-3 po-sm-12 total-block total-final">
      <span class="total-label">Valor Líquido</span>
      <span class="total-amount blue-accent">{{
        (totals.finalValue | currency: "BRL") ?? "R$ 0,00"
      }}</span>
    </div>
  </div>

  <app-pagination
    [pCurrentPage]="currentPage"
    [pTotalItems]="totalItems"
    [pPageSize]="pageSize"
    [pTotalPages]="totalPages"
    (pChangePage)="onPageChange($event.page, $event.pageSize)"
  >
  </app-pagination>

  <po-modal #modal1 [p-hide-close]="true" p-size="auto">
    <po-container>
      <div class="modal-body">
        <div class="mb-3">
          <div class="input-group barCode">
            <ngx-barcode6
              [bc-format]="'ITF'"
              [bc-value]="codigoBarras"
              [bc-display-value]="false"
            ></ngx-barcode6>
          </div>
        </div>

        <div class="mb-3">
          <label for="linhaDigitavel" class="form-label">Linha digitável</label>
          <div class="input-group">
            <input
              type="text"
              id="linhaDigitavel"
              class="form-control"
              [value]="linhaDigitavel"
              readonly
            />
            <po-button
              p-icon="po-icon-copy"
              p-kind="tertiary"
              (p-click)="copyToClipboard('linhaDigitavel')"
            >
            </po-button>
          </div>
        </div>
      </div>
    </po-container>
  </po-modal>

  <po-modal #modal2 [p-hide-close]="true" p-size="sm">
    <po-container>
      <div class="modal-body">
        <div class="mb-3">
          <div class="input-group qrCode">
            <div *ngIf="qrCodeImageUrl">
              <img [src]="qrCodeImageUrl" alt="QR Code" />
            </div>
          </div>
        </div>

        <div class="mb-3">
          <label for="linkCopiaCola" class="form-label"
            >Link Copia e Cola</label
          >
          <div class="input-group">
            <input
              type="text"
              id="linkCopiaCola"
              class="form-control"
              [value]="linkCopiaCola"
              readonly
            />
            <po-button
              p-icon="po-icon-copy"
              p-kind="tertiary"
              (p-click)="copyToClipboard('linkCopiaCola')"
            >
            </po-button>
          </div>
        </div>
      </div>
    </po-container>
  </po-modal>
  <div class="sample-container">
    <po-loading-overlay
      [p-screen-lock]="true"
      [hidden]="isLoadingHidden"
      [p-size]="loadingSize"
      [p-text]="loadingText"
    >
    </po-loading-overlay>
  </div>
  <div class="po-row widget-row"></div>
  <!-- <last-menu-acess></last-menu-acess> -->
</po-page-default>
